import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareVersionDetailEmbedRoute: InvariantJiraRoute = {
	name: 'software-version-detail-embed',
	path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
	exact: true,
};
